import { useEffect } from 'react';
import type { SidebarName } from './components/SidebarPanel';
import { useLatest } from 'hooks/useLatest';

// The study list and its toolbar render into separate React roots; use a
// window event for communication rather than adding more Backbone.
const OPEN_SIDEBAR_EVENT = 'studyList:openSidebar';

export type OpenSidebarRequest = {
  name: SidebarName;
  trigger?: HTMLButtonElement;
};

export const requestOpenSidebar = (request: OpenSidebarRequest) => {
  window.dispatchEvent(
    new CustomEvent<OpenSidebarRequest>(OPEN_SIDEBAR_EVENT, {
      detail: request,
    })
  );
};

export function useOnSidebarRequested(
  onRequest: (request: OpenSidebarRequest) => void
) {
  const latestOnRequest = useLatest(onRequest);

  useEffect(() => {
    const listener = (event: Event) =>
      latestOnRequest.current(
        (event as CustomEvent<OpenSidebarRequest>).detail
      );

    window.addEventListener(OPEN_SIDEBAR_EVENT, listener);
    return () => window.removeEventListener(OPEN_SIDEBAR_EVENT, listener);
  }, [latestOnRequest]);
}
